import { AspectRatio } from "components/ui/aspect-ratio";
import { Card, CardContent, CardFooter, CardHeader } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import ImageUrl from "../image-url/ImageUrl";
import { Service } from "utils/services";
import HelmetHtml from "../helmet-html/HelmetHtml";

export const ShimmerNewFeedLoadingMore: React.FC = () => {
  return (
    <div className="space-y-4 mb-4">
      <Card className="p-4  animate-pulse ">
        {/* User Info Skeleton */}
        <div className="flex items-center space-x-3">
          <div className="bg-gray-300 dark:bg-gray-600 h-10 w-10 rounded-full"></div>
          <div className="flex-1">
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
            <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-1/4 mt-2"></div>
          </div>
        </div>

        {/* Post Content Skeleton */}
        <div className="mt-4 space-y-3">
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-full"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-4/6"></div>
        </div>

        {/* Post Image Skeleton */}
        <div className="mt-3 h-40 bg-gray-300 dark:bg-gray-600 rounded-lg"></div>

        {/* Post Actions Skeleton */}
        <div className="mt-3 flex space-x-4">
          <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-16"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-16"></div>
        </div>
      </Card>
    </div>
  );
};

export const ShimmerNewFeedRightSideSpnsored: React.FC = () => {
  return (
    <div className="animate-pulse space-y-3">
      <AspectRatio ratio={16 / 9} className={`relative overflow-hidden rounded-lg bg-gray-300 dark:bg-gray-600 p-4 space-y-3`}>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-4/6"></div>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-3/6"></div>
      </AspectRatio>

      <AspectRatio ratio={5 / 3} className={`relative overflow-hidden rounded-lg  bg-gray-300 dark:bg-gray-600 p-4 space-y-3`}>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-4/6"></div>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-3/6"></div>
      </AspectRatio>

      <AspectRatio ratio={5 / 3} className={`relative overflow-hidden rounded-lg  bg-gray-300 dark:bg-gray-600 p-4 space-y-3`}>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-4/6"></div>
        <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-3/6"></div>
      </AspectRatio>
    </div>
  );
};

export const ShimmerNewFeedRightJobs: React.FC = () => {
  return (
    <div className="animate-pulse flex flex-col space-y-3">
      {[...Array(3)].map((_, index) => (
        <div key={index} className="flex items-center space-x-3">
          <div className="w-16 h-16 flex-none relative overflow-hidden rounded-lg bg-gray-300 dark:bg-gray-600"></div>

          <div className="flex flex-col space-y-2 w-full">
            <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
            <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-3/6"></div>
            <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-4/6"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const ShimmerNewFeedLeftSideConnector: React.FC = () => {
  return (
    <div className="animate-pulse flex flex-col space-y-3">
      {[...Array(5)].map((_, index) => (
        <div key={index} className="flex items-center space-x-3">
          <div style={{ width: 35, height: 35 }} className="flex-none rounded-full object-cover border shadow-md  bg-gray-300 dark:bg-gray-600"></div>

          <div className="flex flex-col space-y-2 w-full">
            <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const ShimmerNewFeedLeftSideBirthday: React.FC = () => {
  return (
    <div className="flex flex-col space-y-2 w-full">
      <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
      <div className="h-2 bg-gray-200 dark:bg-gray-500 rounded w-4/6"></div>
    </div>
  );
};

export const ShimmerDialogPostReaction: React.FC = () => {
  return (
    <div className="flex flex-col space-y-4">
      {[...Array(5)].map((_, index) => (
        <div key={index} className="flex items-center space-x-4">
          <Skeleton className="h-12 w-12 rounded-full" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-[250px]" />
            <Skeleton className="h-4 w-[200px]" />
          </div>
        </div>
      ))}
    </div>
  );
};

export const ShimmerDialogSuggestionFriend: React.FC = () => {
  return (
    <div id="scrollableDiv" className="mt-4 h-full overflow-y-auto custom-scrollbar">
      <InfiniteScroll
        className={`relative max-h-[calc(100vh-220px)]`}
        dataLength={6}
        next={() => {}}
        scrollThreshold="90%"
        hasMore={false}
        scrollableTarget="scrollableDiv"
        loader={<div className="absolute bottom-2 left-0 w-full flex justify-center"></div>}
      >
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
          {[...Array(6)].map((_, index) => {
            return (
              <div key={index} className="relative  flex-shrink-0 cursor-pointer rounded-xl overflow-hidden ">
                <Card className="rounded-md space-y-2 h-[370px] p-2">
                  <div className="flex flex-col  h-full justify-between">
                    <Skeleton className="w-full object-cover h-[170px] rounded-t-md" />

                    <div className="space-y-2 pt-3">
                      <Skeleton className="h-3 mr-4 " />
                      <Skeleton className="h-2 mr-6" />
                      <Skeleton className="h-2 mr-10" />
                    </div>

                    <div className="flex flex-grow flex-row items-end space-x-2">
                      <Skeleton className="flex-1 h-10  " />
                      <Skeleton className="flex-1 h-10  " />
                      <Skeleton className="flex-1 h-10  " />
                    </div>

                    <div className="flex flex-grow flex-row items-end space-x-2">
                      <Skeleton className="flex-1 h-10  " />
                      <Skeleton className="flex-1 h-10  " />
                    </div>
                  </div>
                </Card>
              </div>
            );
          })}
        </div>
      </InfiniteScroll>
    </div>
  );
};

export const ShimmerDialogEditProduct: React.FC = () => {
  return (
    <div id="scrollableDiv" className=" h-full ">
      <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
      <Skeleton>
        <div className="flex items-center space-x-3 py-[40px] px-5 mt-2">
          <div className="flex-1">
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
            <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-1/4 mt-2"></div>
          </div>
        </div>
      </Skeleton>
      <Skeleton className="mt-4 px-2 rounded-md py-4">
        <Skeleton className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-center">
          {[...Array(6)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>
      {/* type */}
      <Skeleton className="mt-4 px-2 py-3 rounded-md">
        <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>
        <div className="flex items-center mt-2 gap-2">
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
        </div>
      </Skeleton>
      {/* Sales Category */}
      <Skeleton className="mt-4 px-2 py-3 rounded-md">
        <div className="block mb-1 text-md font-medium"></div>
        <Skeleton className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-center">
          {[...Array(12)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>
      {/*  Unit of Measure  */}
      <Skeleton className="mt-4 px-2 py-3 rounded-md">
        <div className="block mb-1 text-md font-medium"></div>
        <Skeleton className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-center">
          {[...Array(14)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>

      <Skeleton className="mt-4 px-2 rounded-md py-4">
        <Skeleton className="grid lg:grid-cols-4 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-between">
          {[...Array(4)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>
    </div>
  );
};

export const ShimmerProductsRender: React.FC = () => {
  return (
    <div className={`grid md:grid-cols-3 ${window.innerWidth <= 1500 ? "lg:grid-cols-4" : "lg-grid-cols-6"}  gap-y-3 gap-x-2 mb-20  rounded-md`}>
      {[...Array(6)].map((_, index) => {
        return (
          <div key={index} className="relative z-10 w-full max-w-sm border rounded-lg  cursor-pointer">
            <div className="absolute h-[30px] w-[95px] z-20 top-0 right-0 dark:bg-gray-700 text-white px-2 py-1 rounded-bl-md rounded-tr-md mt-0">
              <span className="text-sm py-2"></span>
            </div>
            <Skeleton className=" w-full relative overflow-hidden">
              <Skeleton className="absolute w-full h-full rounded-t-md "></Skeleton>
              <ImageUrl className="rounded-t-md cursor-pointer object-cover opacity-0" src="" alt="" />
              <div className={` w-5 h-5 rounded-full flex items-center justify-center absolute left-1 top-1 text-xl  `}></div>
            </Skeleton>
            <div className="p-4 ">
              <p className="text-md font-semibold line-clamp-2 overflow-hidden h-[49px]">
                <Skeleton className="h-4  rounded w-1/2"></Skeleton>
              </p>
              <p className=" font-semibold text-red-500  text-lg h-10">
                <Skeleton className="h-4  rounded w-1/3"></Skeleton>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export const ShimmerStaffRender: React.FC = () => {
  return (
    <div className={`grid md:grid-cols-5 grid-cols-2 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"}   gap-y-3 gap-x-2 mb-20  rounded-md`}>
      {[...Array(window.innerWidth <= 1500 ? 6 : 8)].map((_, index) => {
        return (
          <div key={index} className="relative z-10 w-full max-w-sm border rounded-lg  cursor-pointer">
            <Skeleton className=" w-full relative overflow-hidden">
              <Skeleton className="absolute w-full h-full rounded-t-md "></Skeleton>
              <ImageUrl className="rounded-t-md cursor-pointer object-cover opacity-0" src="" alt="" />
              <div className={` w-5 h-5 rounded-full flex items-center justify-center absolute left-1 top-1 text-xl  `}></div>
            </Skeleton>
            <div className="p-4 ">
              <p className="text-md font-semibold line-clamp-2 overflow-hidden h-[49px]">
                <Skeleton className="h-4  rounded w-1/2"></Skeleton>
              </p>
              <p className=" font-semibold text-red-500  text-lg h-10">
                <Skeleton className="h-4  rounded w-1/3"></Skeleton>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export const ShimmerProductsTableRender: React.FC = () => {
  return (
    <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden ">
      <thead className="sticky top-0 left-0 bg-gray-200 dark:bg-[#2c3a52] w-full">
        <tr className="border-b border-gray-200">
          <th className="py-2 px-4 first:rounded-tl-md last:rounded-tr-md">Image</th>
          <th className="py-2 px-4 text-start">Name</th>
          <th className="py-2 px-4">Price</th>
          <th className="py-2 px-4">Flag</th>
          <th className="py-2 px-4 first:rounded-tl-md last:rounded-tr-md">Status</th>
        </tr>
      </thead>
      <tbody>
        {[...Array(6)].map((_, index) => {
          return (
            <tr key={index} className={`text-center cursor-pointer `}>
              <td className="relative w-[100px] h-[100px]">
                <button
                  onClick={(event) => {
                    event.stopPropagation(); // Prevents opening the edit dialog
                  }}
                  className="absolute inset-0 z-10  mx-auto mt-[32px] w-8 h-8 text-white bg-black/50 rounded-full p-1"
                ></button>
                <ImageUrl src="" className="w-[100px] h-[100px] z-1 mx-auto relative" alt="" />
              </td>
              <td className="py-2 px-4 text-start w-[500px]">
                <p className="text-md font-semibold"></p>
                <span className="text-sm text-gray-500 line-clamp-3"></span>
              </td>
              <td className="py-2 px-4 text-red-700 text-lg"></td>
              <td className="py-2 px-4 text-lg"></td>
            </tr>
          );
        })}
      </tbody>
    </table>
    // <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-y-3 gap-x-2 mb-20  rounded-md">
    //   {[...Array(6)].map((_, index) => {
    //     return (
    //       <>
    //         <div
    //           key={index}
    //           className="relative z-10 w-full max-w-sm border rounded-lg  cursor-pointer bg-gray-50"
    //         >
    //           <div className="absolute h-[30px] w-[95px] z-20 top-0 right-0 bg-gray-300 dark:bg-gray-600 text-white px-2 py-1 rounded-bl-md rounded-tr-md mt-0">
    //             <span className="text-sm py-2"></span>
    //           </div>
    //           <div className=" w-full relative overflow-hidden">
    //             <div className="bg-gray-100 absolute w-full h-full rounded-t-md "></div>
    //             <ImageUrl
    //               className="rounded-t-md cursor-pointer object-cover "
    //               src=""
    //               alt=""
    //             />
    //             <div
    //               className={` w-5 h-5 rounded-full flex items-center justify-center absolute left-1 top-1 text-xl  `}
    //             ></div>
    //           </div>
    //           <div className="p-4 ">
    //             <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[49px]">
    //               <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/2"></div>
    //             </h5>
    //             <p className=" font-semibold text-red-500  text-lg h-10">
    //               <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
    //             </p>
    //           </div>
    //         </div>
    //       </>
    //     );
    //   })}
    // </div>
  );
};

export const ShimmerCategoriesRender: React.FC = () => {
  return (
    <div className="space-x-2 flex">
      {[...Array(6)].map((_, index) => {
        return (
          <div key={index} className="flex items-center">
            <Skeleton className={`w-[200px]  rounded-md cursor-pointer font-semibold  `}>
              <div className="flex group">
                <div className="flex relative lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 ">
                  {/* Image */}

                  {/* Hover Overlay */}
                </div>
                <p className="text-md font-semibold line-clamp-2 px-2 overflow-hidden h-[49px]"></p>
              </div>
            </Skeleton>
          </div>
        );
      })}
    </div>
  );
};

export const ShimmerDepartmentRender: React.FC = () => {
  return (
    <div className="space-x-2 flex">
      {[...Array(6)].map((_, index) => {
        return (
          <div key={index} className="flex items-center">
            <Skeleton className={`w-[200px]  rounded-md cursor-pointer font-semibold  `}>
              <div className="flex group">
                <div className="flex relative lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 ">
                  {/* Image */}

                  {/* Hover Overlay */}
                </div>
                <p className="text-md font-semibold line-clamp-2 px-2 overflow-hidden "></p>
              </div>
            </Skeleton>
          </div>
        );
      })}
    </div>
  );
};

export const ShimmerDialogEditCategories: React.FC = () => {
  return (
    <div id="scrollableDiv" className="h-[550px]overflow-y-auto custom-scrollbar mt-[20px] ">
      <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
      <Skeleton>
        <div className="flex items-center space-x-3 py-[10px] px-5 mt-2">
          <div className="flex-1">
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
            <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-1/4 mt-2"></div>
          </div>
        </div>
      </Skeleton>
      <Skeleton className="mt-4 px-2 rounded-md py-4">
        <Skeleton className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-center">
          {[...Array(6)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>
      {/* type */}
      <Skeleton className="mt-4 px-2 py-3 rounded-md">
        <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>
        <div className="flex items-center mt-2 gap-2">
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
        </div>
      </Skeleton>
      {/* Sales Category */}
      <Skeleton className="mt-4 px-2 py-3 rounded-md">
        <div className="block mb-1 text-md font-medium"></div>
        <Skeleton className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-center">
          {[...Array(12)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>
      {/*  Unit of Measure  */}
      <Skeleton className="mt-4 px-2 py-3 rounded-md">
        <div className="block mb-1 text-md font-medium"></div>
        <Skeleton className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-center">
          {[...Array(14)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>

      <Skeleton className="mt-4 px-2 rounded-md py-4">
        <Skeleton className="grid lg:grid-cols-4 md:grid-cols-4 grid-cols-3 gap-2 items-center justify-between">
          {[...Array(4)].map((_, index) => {
            return <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded "></div>;
          })}
        </Skeleton>
      </Skeleton>
    </div>
  );
};

export const ShimmerNewFeedStories: React.FC = () => {
  return (
    <div className="relative mb-4">
      {/* Story List */}
      <div className={`flex overflow-x-auto space-x-2 pt-2 no-scrollbar scrollbar-custom`}>
        {[...Array(7)].map((_, index) => (
          <div key={index} className="relative w-24 h-40 flex-shrink-0 cursor-pointer rounded-xl overflow-hidden">
            {index === 100 ? (
              <div className="relative w-full h-full rounded-xl overflow-hidden bg-gray-700">
                {/* Image Section (70%) */}
                <div className="h-[70%] bg-gray-700">
                  <img src={Service.userAuth.picture} alt="Create story" className="w-full h-full object-cover" />
                </div>

                {/* White Bottom Section (30%) */}
                <div className="h-[30%] bg-gray-700 relative">
                  <div className="mt-6 text-center text-xs font-medium text-white">Create story</div>
                </div>

                {/* Button Positioned at the Intersection */}
                <div className="absolute top-[70%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-500 p-1.5 rounded-full border-4 border-white">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </div>
              </div>
            ) : (
              <>
                <div className="flex w-full h-full bg-gray-200 dark:bg-gray-700  "></div>

                <div className={`absolute top-2 left-2 w-8 h-8 rounded-full `}>
                  <Skeleton className="w-8 h-8 rounded-full" />
                </div>

                <div className="absolute bottom-2 left-2 right-2  ">
                  <Skeleton className="h-4 w-12" />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export const ShimmerViewStories: React.FC = () => {
  return (
    <div className="flex flex-1 flex-col  space-y-2 items-center p-2">
      <div className="flex flex-row w-full h-full justify-center items-center p-2 space-x-4">
        <Skeleton className="w-14 h-14 rounded-full top-1/2 transform -translate-y-1/2" />

        <div className="flex flex-col h-full aspect-[9/18] p-3 bg-muted/50 rounded-lg">
          <div className=" flex items-center space-x-4">
            <Skeleton className="h-12 w-12 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-[250px]" />
              <Skeleton className="h-4 w-[200px]" />
            </div>
          </div>
        </div>

        <div className="flex flex-col h-full relative justify-center">
          <Skeleton className="w-14 h-14 rounded-full top-1/2 transform -translate-y-1/2" />

          <div className="absolute bottom-4 flex flex-col  space-y-2">
            <Skeleton className="w-14 h-14 rounded-full " />
            <Skeleton className="w-14 h-14 rounded-full " />
            <Skeleton className="w-14 h-14 rounded-full " />
          </div>
        </div>
      </div>

      <Skeleton className="h-[50px] w-[500px] rounded-lg" />
    </div>
  );
};
// ---shimmer loading Account Dashboard----
export const ShimmerFollowByGender: React.FC = () => {
  return (
    <Card className="flex flex-col animate-pulse">
      <CardContent className="flex-1 pb-0 flex items-center justify-center">
        <Skeleton className="w-[180px] h-[180px] rounded-full "></Skeleton>
      </CardContent>
      <CardFooter className="flex-col gap-2 text-sm md:text-[12px]">
        <Skeleton className="w-32 h-4  rounded-md"></Skeleton>
      </CardFooter>
    </Card>
  );
};

export const ShimmerFollowersbyAge: React.FC = () => {
  return (
    <Card className="lg:col-span-2 animate-pulse">
      <CardHeader>
        <Skeleton className="w-40 h-4  rounded-md"></Skeleton>
      </CardHeader>
      <CardContent className="h-[230px] flex items-center justify-center">
        <Skeleton className="w-full h-[200px]  rounded-md"></Skeleton>
      </CardContent>
    </Card>
  );
};

export const ShimmerFollowersbyMCorn: React.FC = () => {
  return (
    <Card className="flex flex-col animate-pulse">
      <CardContent className="flex-1 pb-0 flex items-center justify-center">
        <Skeleton className="w-[180px] h-[180px] rounded-full "></Skeleton>
      </CardContent>
      <CardFooter className="flex-col gap-2 text-sm md:text-[12px]">
        <Skeleton className="w-32 h-4  rounded-md"></Skeleton>
      </CardFooter>
    </Card>
  );
};

export const ShimmerFollowersbyCountry: React.FC = () => {
  return (
    <Card className="animate-pulse">
      <CardHeader>
        <Skeleton className="w-40 h-4 rounded-md"></Skeleton>
      </CardHeader>
      <CardContent className="h-[230px] flex items-center justify-center">
        <Skeleton className="w-full h-[200px] rounded-md"></Skeleton>
      </CardContent>
    </Card>
  );
};

export const ShimmerFollowersbygrowthlast7days: React.FC = () => {
  return (
    <Card className="col-span-2 animate-pulse">
      <CardHeader>
        <Skeleton className="w-40 h-4 rounded-md"></Skeleton>
      </CardHeader>
      <CardContent className="h-[230px] flex items-center justify-center">
        <Skeleton className="w-full h-[200px] rounded-md"></Skeleton>
      </CardContent>
    </Card>
  );
};

export const ShimmerFollowersbyAudienceContents: React.FC = () => {
  return (
    <Card className="animate-pulse">
      <CardHeader>
        <Skeleton className="w-40 h-4 rounded-md"></Skeleton>
      </CardHeader>
      <CardContent className="h-[230px] p-0 flex flex-col justify-center items-center">
        <div className="grid grid-cols-2 gap-x-[50px] gap-y-4">
          {/* Skeleton - Followers */}
          <div className="flex flex-col items-center">
            <Skeleton className="w-[60px] h-[60px] rounded-full"></Skeleton>
            <Skeleton className="w-24 h-4 rounded-md mt-2"></Skeleton>
          </div>

          {/* Skeleton - Following */}
          <div className="flex flex-col items-center">
            <Skeleton className="w-[60px] h-[60px] rounded-full"></Skeleton>
            <Skeleton className="w-24 h-4 rounded-md mt-2"></Skeleton>
          </div>

          {/* Skeleton - Posts */}
          <div className="flex flex-col items-center">
            <Skeleton className="w-[60px] h-[60px] rounded-full"></Skeleton>
            <Skeleton className="w-24 h-4 rounded-md mt-2"></Skeleton>
          </div>

          {/* Skeleton - Loves */}
          <div className="flex flex-col items-center">
            <Skeleton className="w-[60px] h-[60px] rounded-full"></Skeleton>
            <Skeleton className="w-24 h-4 rounded-md mt-2"></Skeleton>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const ShimmerAccountDashboardTopPosts: React.FC = () => {
  return (
    <>
      <div className="col-span-3 row-span-2">
        {/* <Skeleton className="w-40 h-4 rounded-md  ms-[20px] mb-[18px]"></Skeleton> */}
        <div className="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-1 gap-2">
          {[...Array(4)].map((_, index) => (
            <Card key={index} className="overflow-hidden p-2  ">
              <div className="flex py-[9px] ps-[9px]">
                <Skeleton className="w-[230px] h-[400px]" />
                <div className="ps-5 mt-5">
                  <Skeleton className="w-48 h-6" />
                  <Skeleton className="w-24 h-6 mt-2" />
                  <div className="flex flex-col justify-start w-full gap-2 mt-5">
                    {[...Array(4)].map((_, index) => (
                      <div key={index} className="flex flex-col justify-start h-[60px]">
                        <Skeleton className="w-16 h-4" />
                        <div className="flex justify-start -space-x-4 rtl:space-x-reverse mt-1">
                          {[...Array(3)].map((_, index) => (
                            <span key={index} className="w-8 h-8 rounded-full border-2 bg-[#f2f6f9] dark:bg-[#141d2e]" />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
};

export const ShimmerAccountDashboardTopPostsHeader: React.FC = () => {
  return (
    <>
      <Skeleton className="w-40 h-4 rounded-md ms-[20px] "></Skeleton>
    </>
  );
};

export const ShimmerAccoutOverView: React.FC = () => {
  return (
    <Card className=" h-[435px]">
      <CardHeader>
        <Skeleton className="w-40 h-4 rounded-md"></Skeleton>
      </CardHeader>
      <div className="px-5">
        <Skeleton className="w-full my-4 h-4 rounded-md"></Skeleton>
        <Skeleton className="w-full my-5 h-4 rounded-md"></Skeleton>
        <Skeleton className="w-full my-4 h-4 rounded-md"></Skeleton>
        <Skeleton className="w-full my-4 h-4 rounded-md"></Skeleton>
        <Skeleton className="w-full my-4 h-4 rounded-md"></Skeleton>
      </div>
      <div className="flex justify-between items-center w-full px-5 mb-5 mt-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex flex-col items-center">
            <Skeleton className="w-[60px] h-[60px] rounded-full" />
            <Skeleton className="w-16 h-4 mt-2" />
          </div>
        ))}
      </div>
    </Card>
  );
};

export const ShimmerFollowingUserListLoading: React.FC = () => {
  return (
    <div className="flex flex-col space-y-2 pl-2 mt-2">
      {[...Array(10)].map((_, i) => (
        <div key={i} className="flex items-center space-x-2 w-full">
          <Skeleton className="w-12 h-12 rounded-full shrink-0" />
          <div className="space-y-2 w-full">
            <Skeleton className="h-3 w-3/4" />
            <Skeleton className="h-2 w-2/4" />
          </div>
        </div>
      ))}
    </div>
  );
};

export const ShimmerFollowingUserListLoadMore: React.FC = () => {
  return (
    <div className="flex flex-col space-y-2 pl-2 mt-2">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="flex items-center space-x-2 w-full">
          <Skeleton className="w-12 h-12 rounded-full shrink-0" />
          <div className="space-y-2 w-full">
            <Skeleton className="h-3 w-3/4" />
            <Skeleton className="h-2 w-2/4" />
          </div>
        </div>
      ))}
    </div>
  );
};

export const ShimmerFollowingComments: React.FC = () => {
  return (
    <div className="flex flex-col space-y-4 pl-2">
      {[...Array(3)].map((_, i) => (
        <div className="flex space-x-2 w-full ">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="space-y-2">
            <Skeleton className="h-12 w-48" />
            <Skeleton className="h-2 w-40" />
          </div>
        </div>
      ))}
    </div>
  );
};

export const ShimmerFollowingPosts: React.FC = () => {
  return (
    <div className="flex flex-1 ">
      <div className="w-full h-full overflow-hidden touch-none">
        <div className="relative w-full h-full">
          <div
            className="absolute top-0  w-full h-full transition-transform duration-500 ease-in-out flex flex-row justify-center py-3 "
            style={{
              transform: `translateY(${0}%)`,
              zIndex: 0,
            }}
          >
            <div className="flex aspect-[8/16] rounded-lg relative bg-muted/50 "></div>

            <div className="flex flex-col items-start justify-end ml-4 space-y-4">
              <div className="absolute bottom-4 flex flex-col  space-y-2">
                <Skeleton className="w-12 h-12 rounded-full " />
                <Skeleton className="w-12 h-12 rounded-full " />
                <Skeleton className="w-12 h-12 rounded-full " />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const ShimmerPostDetail: React.FC = () => {
  return (
    <div className="flex flex-col lg:grid lg:grid-cols-3  overflow-hidden h-[100vh]">
      <HelmetHtml title="Post-Content" description="This is PostContent" />
      {/* Post Content */}
      <div className="  bg-gray-200 dark:bg-gray-700  lg:col-span-2 md:h-[60vh] lg:h-auto flex flex-col items-center justify-between text-center px-[30px] py-[9px] h-[100vh]">
        <div className="flex justify-between items-center w-full  ">
          <Skeleton className="h-12 w-12 rounded-full" />
          <div className="flex items-center justify-center gap-3">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </div>
        <div className="flex justify-end  items-center w-full mt-[200px]">
          <div className="flex flex-col w-full  justify-end gap-3 items-end">
            <Skeleton className="h-12 w-12 rounded-full" />
            <Skeleton className="h-12 w-12 rounded-full" />
          </div>
        </div>
        <br />
        <div className="flex justify-end items-center w-full   ">
          <div className="flex justify-end items-center w-full gap-3 ">
            <Skeleton className="h-12 w-12 rounded-full" />
            <Skeleton className="h-7 w-[180px] rounded-full" />
          </div>
        </div>
      </div>
      <div className="flex flex-col h-screen relative justify-between  dark:bg-background pt-4  px-[10px] py-[9px]  ">
        <div className="flex flex-col justify-start items-start ">
          <div className="flex justify-between items-center w-full  ">
            <div className="flex items-center space-x-4">
              <Skeleton className="h-12 w-12 rounded-full" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-[250px]" />
                <Skeleton className="h-4 w-[200px]" />
              </div>
            </div>
            <div className="flex items-center justify-center gap-3">
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
          </div>
          <div className="flex items-center justify-center gap-3 mt-[50px]">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex  space-y-2 w-full items-start justify-start gap-3">
            {/* <div className="w-16 h-16 rounded-md bg-gray-200 dark:bg-[#4E4F50] animate-pulse"></div> */}
            <Skeleton className="h-8 w-8 rounded-full mt-2" />
            <div className="border relative p-2 rounded-2xl w-full ">
              <div className="flex flex-col">
                {/* Skeleton for Textarea */}
                <Skeleton className="w-full h-10   rounded-md animate-pulse"></Skeleton>

                <div className="flex justify-between items-center mt-2">
                  <div className="flex space-x-2 items-center">
                    {/* Skeleton for Emoji Button */}
                    <Skeleton className="w-10 h-10 rounded-full   animate-pulse"></Skeleton>

                    <Skeleton className="w-10 h-10 rounded-full   animate-pulse"></Skeleton>
                  </div>

                  <Skeleton className="w-10 h-10 rounded-full  animate-pulse"></Skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ShimmerFriends: React.FC = () => {
  return (
    <div className="flex flex-1 flex-col h-full ">
      <div className="flex justify-between items-center my-2">
        <Skeleton className="h-4 w-[200px]" />
      </div>
      <div className="relative mb-4  flex items-center justify-center">
        <div className={`flex overflow-x-auto space-x-2 pt-2 no-scrollbar `}>
          {Array.from({ length: 5 }).map((_, index) => (
            <div className="flex flex-col items-center justify-center">
              <div className="flex flex-col gap-3 items-center space-x-4">
                <Skeleton className="h-12 w-12 rounded-full" />
                <div className="space-y-2">
                  <Skeleton className="h-3 w-[100px]" />
                  <Skeleton className="h-3 w-[90px]" />
                </div>
                <Skeleton className="h-7 w-[100px] rounded-md" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const ShimmerCampaingsDetail: React.FC = () => {
  return (
    <>
      <div className=" grid grid-cols-3 pb-1 rounded-lg  mb-4 w-full h-full">
        <div className=" col-1 ">
          <div className="aspect-[9/16] cursor-pointer relative  ">
            <div className="rounded-md animate-pulse border-none shadow-none">
              <Skeleton className="w-full h-[600px]  rounded-t-md" />
            </div>
          </div>
        </div>
        <div className=" col-span-2">
          <div className="flex flex-1 pl-5 space-y-4  flex-col justify-start">
            {/* <div className="w-1/2 space-y-4"> */}
            {/* Toggle */}
            <div className="flex justify-between items-center">
              <Skeleton className="h-4 w-32  rounded" />
              <Skeleton className="h-6 w-12  rounded-full" />
            </div>

            {/* Description */}
            <Skeleton className="h-4 w-full  rounded" />
            <Skeleton className="h-4 w-5/6  rounded" />
            <Skeleton className="h-4 w-4/6  rounded" />

            {/* Gender options */}
            <div className="flex gap-4">
              <Skeleton className="h-10 w-16  rounded" />
              <Skeleton className="h-10 w-16  rounded" />
              <Skeleton className="h-10 w-16  rounded" />
            </div>

            {/* Age slider */}
            <Skeleton className="h-4 w-full  rounded" />
            <Skeleton className="h-4 w-2/3  rounded" />

            {/* Locations input */}
            <Skeleton className="h-10 w-full  rounded" />

            {/* Duration section */}
            <div className="flex gap-4">
              <Skeleton className="h-10 w-32  rounded" />
              <Skeleton className="h-10 w-32  rounded" />
            </div>
            <Skeleton className="h-4 w-full  rounded" />
            <Skeleton className="h-4 w-2/3  rounded" />
            <Skeleton className="h-10 w-full  rounded" />
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};
export const SuggestionSearch: React.FC = () => {
  return (
    <>
      {[...Array(5)].map((_, index) => (
        <Card key={index} className="rounded-md animate-pulse">
          <div className="w-full h-[200px]  rounded-t-md" />

          <div className="p-2 space-y-2">
            <div className="flex items-center space-x-2">
              <div className="w-32 h-5  rounded" />
              <div className="w-6 h-6  rounded-full" />
            </div>
            <div className="w-40 h-4  rounded" />
          </div>

          <div className="grid grid-cols-3 text-center px-4 py-2 gap-2">
            <div>
              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
            </div>
            <div>
              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
            </div>
            <div>
              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
            </div>
          </div>

          <div className="p-2">
            <Skeleton className="w-full h-10  rounded" />
          </div>
        </Card>
      ))}
    </>
  );
};

export const SkeletonPublicHoliday: React.FC = () => {
  return (
    <div className="w-full mb-5 mt-2 border rounded-md p-2 ">
      <table className="w-full">
        <thead className="w-full">
          <tr className="">
            <th>
              <Skeleton className="w-[10px] h-4 rounded-tl-md rounded-tr-md" />
            </th>
            <th>
              <Skeleton className="w-1/2 h-4" />
            </th>
            <th>
              <Skeleton className="w-1/2 h-4" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(9)].map((_: any, index: number) => {
            return (
              <tr key={index}>
                <td className="w-[180px] h-[80px]">
                  <Skeleton className="w-[100px] h-full rounded-tl-md rounded-bl-md" />
                </td>
                <td className=" ">
                  <Skeleton className="w-1/2 h-4" />
                </td>
                <td className="">
                  <Skeleton className="w-1/2 h-4" />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

